module.exports = __webpack_public_path__ + "img/mobile_t14.0952ed82.png";